import { IJob as IJobModel } from '~/models';
import { bulkConfirmAdapter } from './adapters/bulkConfirmAdapter';
import { jobsAdapter } from './adapters/jobsAdapter';
import { jobsApi } from './jobsApi';
import { IAverageRating } from './types/averageRateTypes';
import { IBulkConfirmPayload } from './types/bulkConfirmTypes';
import { IGetJobsParams, IJob } from './types/jobsTypes';

async function getJobs(params: IGetJobsParams): Promise<IJob[]> {
  const jobsAPI = await jobsApi.getJobs(params);
  return jobsAPI.map(jobsAdapter.toJob);
}

async function getJob(jobId: string): Promise<IJobModel> {
  // Keep the detail payload raw because detail/invite consumers read API fields directly.
  return jobsApi.getJob(jobId);
}

async function getJobCandidates(jobId: string): Promise<unknown[]> {
  return jobsApi.getJobCandidates(jobId);
}

async function getCandidateOvertime(
  jobId: string,
  candidateId: string,
): Promise<Partial<IJobModel>> {
  return jobsApi.getCandidateOvertime(jobId, candidateId);
}

async function bulkConfirmJobs(params: IBulkConfirmPayload): Promise<string[]> {
  const request = bulkConfirmAdapter.toBulkConfirmRequest(params);
  return await jobsApi.bulkConfirmJobs(request);
}

async function getAverageRate(officeId: string): Promise<IAverageRating> {
  return jobsApi.getAverageRate(officeId);
}

export const jobsService = {
  getJobs,
  getJob,
  getJobCandidates,
  getCandidateOvertime,
  bulkConfirmJobs,
  getAverageRate,
};
